import {
  HIDE_CHECK_WIRE_MODAL,
  SHOW_CHECK_WIRE_MODAL,
  SET_CREATION_SUCCEEDED,
} from '@/store/mutation-types';
import HttpService from '@/api/HttpService';

export default {
  namespaced: true,
  state: {
    isCheckWireModalVisible: false,
    creationSucceeded: false,
    accountId: '',
    fundingSources: [],
  },
  mutations: {
    [SET_CREATION_SUCCEEDED](state, creationStatus) {
      state.creationSucceeded = creationStatus;
    },
    [SHOW_CHECK_WIRE_MODAL](state, { accountId, fundingSources }) {
      state.isCheckWireModalVisible = true;
      state.accountId = accountId;
      state.fundingSources = fundingSources;
    },
    [HIDE_CHECK_WIRE_MODAL](state) {
      state.isCheckWireModalVisible = false;
    },
    [SHOW_CHECK_WIRE_MODAL](state, { accountId, fundingSources }) {
      state.isCheckWireModalVisible = true;
      state.accountId = accountId;
      state.fundingSources = fundingSources;
    },
  },
  actions: {
    createAccountFundingSources({ commit }, { accountId, payload }) {
      return HttpService.postV2(`/accounts/${accountId}/funding-sources`, payload)
        .then(res => res)
        .catch(error => Promise.reject(error));
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/checkWireModal.js